import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { PFrameRoutes } from "../shared/pframe-routes";

import { DataService } from "./data.service";

@Injectable()
export class LoggedInGuard  {
  constructor(private router: Router, private dataService: DataService) {}

  canActivate() {
    if (this.dataService.IsLoggedIn()) return true;
    else {
      this.router.navigate([PFrameRoutes.login]);
      return false;
    }
  }
}
